module.exports = __webpack_public_path__ + "static/img/skyline-left.7db7aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/skyline-left.png
// module id = 682
// module chunks = 64